<div class="add-filter">
  <p class="add-filter__title">Build the filter manually</p>
  <p class="add-filter__description">Set the label, data column and control type for this filter.</p>

  <div class="add-filter__fields">
    <div class="add-filter__field">
      <label class="add-filter__field-label">Filter label <span class="add-filter__required">*</span></label>
      <input
        type="text"
        class="add-filter__input"
        placeholder="e.g. Application PADU"
        [(ngModel)]="form.label"
        (ngModelChange)="onFieldChange()"
      />
    </div>

    <div class="add-filter__field">
      <label class="add-filter__field-label">Unique key <span class="add-filter__required">*</span></label>
      <input
        type="text"
        class="add-filter__input"
        placeholder="e.g. application_padu"
        [(ngModel)]="form.name"
        (ngModelChange)="onFieldChange()"
      />
    </div>

    <div class="add-filter__field">
      <label class="add-filter__field-label">Data column <span class="add-filter__required">*</span></label>
      <input
        type="text"
        class="add-filter__input"
        placeholder="e.g. PADU_Status"
        [(ngModel)]="form.column"
        (ngModelChange)="onFieldChange()"
      />
    </div>

    <div class="add-filter__field">
      <label class="add-filter__field-label">Control type <span class="add-filter__required">*</span></label>
      <mat-select class="add-filter__select" [(ngModel)]="form.type" (selectionChange)="onFieldChange()">
        @for (option of controlTypeOptions; track option) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </div>

    <div class="add-filter__field">
      <label class="add-filter__field-label">Default selection</label>
      <mat-select class="add-filter__select" [(ngModel)]="form.default_selection" (selectionChange)="onFieldChange()">
        @for (option of defaultSelectionOptions; track option) {
        <mat-option [value]="option">{{ option }}</mat-option>
        }
      </mat-select>
    </div>
  </div>
</div>
